import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import person1 from '../assets2/images/person-sq-1-min.jpg';
import person2 from '../assets2/images/person-sq-2-min.jpg';
import person5 from '../assets2/images/person-sq-5-min.jpg';

const testimonials = [
  {
    name: 'Ramesh Patel',
    role: 'Kirana Store Owner',
    place: 'Ahmedabad',
    img: person2,
    quote:
      'Earlier I struggled with handwritten invoices and errors. Now everything is digital and fast. I can even share bills on WhatsApp instantly!',
  },
  {
    name: 'Priya Agarwal',
    role: 'Garments Wholesaler',
    place: 'Jaipur',
    img: person1,
    quote:
      'Inventory tracking, e-Way bills, payment reminders - all in one place. It saves me hours every week.',
  },
  {
    name: 'Mohammed Imran',
    role: 'Electronics Dealer',
    place: 'Hyderabad',
    img: person5,
    quote:
      'I was afraid of GST filing and reports. But HamaraBillBook made it all easy to understand. Highly recommended!',
  },
];

const Testimonial = () => (
  <section className="section testimonials__v2" id="testimonials">
    <Container>
      <Row className="mb-5">
        <Col lg={5} className="mx-auto text-center">
          <span className="subtitle mb-3">Testimonials</span>
          <h2 className="mb-3">What Our Customers Say</h2>
          <p>Trusted by Lakhs of Businesses Across India</p>
        </Col>
      </Row>
      <Row>
        {testimonials.map((t, idx) => (
          <Col md={6} lg={4} key={idx} className="mb-4">
            <Card className="testimonial rounded-4 p-4 h-100">
              <h5 className="mb-3">{t.headline}</h5>
              <blockquote className="mb-3">&ldquo;{t.quote}&rdquo;</blockquote>
              <div className="testimonial-author d-flex gap-3 align-items-center">
                <div className="author-img">
                  <img
                    className="rounded-circle img-fluid"
                    src={t.img}
                    alt={t.name}
                  />
                </div>
                <div className="lh-base">
                  <strong className="d-block">{t.name}</strong>
                  <span>{t.role}, {t.place}</span>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default Testimonial;
